import React from 'react'
import cn from 'classnames'

import GA from '../../shared/tracking/ga'

import { h3, text } from '../typography/index'
import RiseContent from './rise-content'
import GiftForm from '../gift-form'
import Loader from '../common/loader'
import { setStage } from '../common/analytics-staging'
import Button from '../common/button'
import * as API from '../../service/user'
import Modal from '../modal'
import { content } from '../gift-texts/gift-texts'
import GiftContext from '../../context/context'
import { getParamFromUrl } from '../../utils/url'
import { RISE_MODE, FOUNDERS_MODE, MMC_MODE } from '../../shared/modes'
import './gift-rise.sass'
import { CONTENT_LOGIN, CONTENT_ADDCARD, CONTENT_SIGNUP, CONTENT_DONE } from '../../shared/contentStates'
import ExternalLink from '../common/externalLink'
import Logo from '../../img/brand-new-logo.svg'

import mmcLogo from './img/mmcLogo'
import planeDesktop from './img/planeDesktop'
import planeMobile from './img/planeMobile'

class Rise extends React.Component {
  static contextType = GiftContext

  content = React.createRef()

  state = {
    contentState: CONTENT_LOGIN,
    isLoading: true,
    isError: false,
    modalError: null,
  }

  setIsLoading = (isLoading) => this.setState({ isLoading })

  setIsError = (isError) => this.setState({ isError })

  closeModal = () => {
    if (this.state.modalError.link) window.location.replace('https://flyxo.com')
    else this.setState({ modalError: null })
  }

  errorModal = (key, action = 'close') => {
    const actions = {
      flyxo: {
        text: 'Go to FlyXO',
        link: 'https://flyxo.com',
      },
      close: {
        text: 'Try again',
        link: null,
      },
    }

    const modalError = actions[action]
    modalError.message = key.message

    this.setState({ modalError })
  }

  switchContent = (contentState, wrapper) => {
    if (contentState === CONTENT_LOGIN) {
      GA.send({
        name: 'signin',
        category: 'signin',
        action: 'switch',
      })
    }

    if (contentState === CONTENT_SIGNUP) {
      GA.send({
        name: 'signup',
        category: 'signup',
        action: 'switch',
      })
    }

    if (this.content.current) this.content.current.classList.add('animation')
    if (wrapper) wrapper.classList.add('animation')
    if (contentState === CONTENT_ADDCARD) setStage(2)

    // TODO ontransionend ? with css refactoring
    if (!this.content.current) this.setState({ contentState })
    else
      setTimeout(() => {
        this.setState({ contentState })
        this.content.current.classList.remove('animation')
        if (wrapper) wrapper.classList.remove('animation')
      }, 200)
  }

  getCodeFromURI() {
    const code = getParamFromUrl('code')
    return code
  }

  componentDidMount() {
    if (this.props.founders) {
      this.initFoundersMode()
    } else if (this.props.mmc) {
      this.initMmcMode()
    } else {
      this.context.updateState({
        mode: RISE_MODE,
        lang: 'en',
      })
      this.setState({ isLoading: false })
    }
    setStage(1)
  }

  async initFoundersMode() {
    const code = this.getCodeFromURI()
    if (code)
      if (code && code.includes('FOUNDERSCARD')) {
        try {
          const res = await API.checkCode(code)
          if (res.status) {
            this.context.updateState({
              mode: FOUNDERS_MODE,
              code,
              lang: 'en',
            })
            this.setState({ contentState: CONTENT_LOGIN, isLoading: false })
          } else throw new Error()
        } catch (e) {
          this.errorModal({ message: "Sorry, we don't have this code" }, 'flyxo')
        }
      } else {
        this.errorModal({ message: 'Sorry, you need the unique code' }, 'flyxo')
      }
  }

  async initMmcMode() {
    const code = this.getCodeFromURI()

    if (!code) return this.errorModal({ message: 'Sorry, you need the unique code' }, 'flyxo')

    try {
      const res = await API.checkCode(code)
      if (res.status) {
        this.context.updateState({
          mode: MMC_MODE,
          code,
          lang: 'en',
        })
        this.setState({ contentState: CONTENT_SIGNUP, isLoading: false })
      } else throw new Error()
    } catch (e) {
      this.errorModal({ message: "Sorry, we don't have this code" }, 'flyxo')
    }
  }

  getLegal() {
    const { contentState } = this.state
    if (this.context.formData.mode === FOUNDERS_MODE) return content.rise.legalFounders()
    if (this.context.formData.mode === MMC_MODE) {
      if (contentState === CONTENT_DONE) return null
      return content.mmc.legal()
    }
    return content.rise.legal()
  }

  render() {
    const { contentState, isLoading } = this.state
    const { mode } = this.context.formData
    const isMmc = mode === MMC_MODE

    return (
      <div className={cn('flyxo-landing --rise', { '--mmc': isMmc })}>
        <div className={cn('full-view --rise', { '--mmc': isMmc })} />
        <div
          className={`content --rise --${
            contentState && contentState !== CONTENT_LOGIN && contentState !== CONTENT_SIGNUP
              ? 'no-form'
              : ''
          }`}
        >
          <div className={cn('content-top', { '--mmc': isMmc })}>
            <ExternalLink
              to="https://flyxo.com"
              className={cn(
                'content-top__brand-logo',
                { '--mmc': isMmc },
              )
            }>
              <img src={Logo} alt="XO logo" />
            </ExternalLink>
            { isMmc && <picture className="content-top__mmc-logo">
              <source
                srcSet={`${mmcLogo.webp} 1x, ${mmcLogo.webp2x} 2x`}
                type="image/webp"
              />
              <img
                srcSet={`${mmcLogo.png} 1x, ${mmcLogo.png2x} 2x`}
                src={mmcLogo.png2x}
                type="image/jpeg"
                alt="Monticello Motor Club"
              />
            </picture> }
          </div>
          {isLoading ? (
            <Loader />
          ) : (
            <div className="content-middle">
              <div className={cn('content-middle__item content-text', { '--mmc': isMmc })} ref={this.content}>
                {!isLoading && contentState ? (
                  <RiseContent
                    contentState={this.state.contentState}
                    isFinish={this.props.isFinish}
                    setIsLoading={this.setIsLoading}
                    setIsError={this.setIsError}
                    switchContent={this.switchContent}
                    errorModal={this.errorModal}
                    isMmc={isMmc}
                  />
                ) : null}
              </div>
              <div className={cn('content-middle__item content-form', { '--mmc': isMmc })}>
                {!isLoading &&
                contentState &&
                [CONTENT_LOGIN, CONTENT_SIGNUP].includes(contentState) ? (
                  <GiftForm switchContent={this.switchContent} errorModal={this.errorModal} />
                ) : null}
              </div>
            </div>
          )}

          { !isLoading && <>
            <div className="content-footer">{this.getLegal()}</div>

            { isMmc && <>
              <picture className="plane --desktop">
                <source
                  srcSet={`${planeDesktop.webp} 1x, ${planeDesktop.webp2x} 2x`}
                  type="image/webp"
                />

                <img
                  srcSet={`${planeDesktop.jpg} 1x, ${planeDesktop.jpg2x} 2x`}
                  src={planeDesktop.jpg2x}
                  type="image/jpeg"
                  alt="Plane"
                />
              </picture>

              <picture className="plane --mobile">
                <source
                  srcSet={`${planeMobile.webp} 1x, ${planeMobile.webp2x} 2x`}
                  type="image/webp"
                />

                <img
                  srcSet={`${planeMobile.jpg} 1x, ${planeMobile.jpg2x} 2x`}
                  src={planeMobile.jpg2x}
                  type="image/jpeg"
                  alt="Plane"
                />
              </picture>

              { content.mmc.disclaimer() }               
            </> }
          </> }
        </div>

        {this.state.modalError ? (
          <Modal small onClose={this.closeModal}>
            <div className="landing-modal">
              <div className="landing-modal__content">
                {h3({}, <span>Activation error</span>)}
                {text({ margin: '30px 0' }, <span>{this.state.modalError.message}</span>)}
                {
                  <Button className="modal__button" onClick={this.closeModal}>
                    {this.state.modalError.text}
                  </Button>
                }
              </div>
            </div>
          </Modal>
        ) : null}
      </div>
    )
  }
}

export default Rise
